var map = {
	"./img_1.jpg": 98748,
	"./img_2.jpg": 108,
	"./img_3.jpg": 67298,
	"./img_4.jpg": 99587,
	"./img_5.jpg": 12568,
	"./img_6.jpg": 81516,
	"./img_7.jpg": 87441,
	"./img_8.jpg": 25013,
	"./img_9.jpg": 5964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81609;